export const validateFile = (file: File): string | null => {
  const MAX_SIZE = 10 * 1024 * 1024;
  const IMAGE_TYPES = ["image/jpeg", "image/png"];

  if (file.size > MAX_SIZE) {
    return `ファイルサイズは${MAX_SIZE / 1024 / 1024}MB以内でお願いします。`;
  }

  if (!IMAGE_TYPES.includes(file.type)) {
    return `アップロード可能なファイル形式はjpg、jpeg、pngです。`;
  }

  return null;
};
